import { render, staticRenderFns } from "./ArchiveStock.vue?vue&type=template&id=9bb6a2d6&"
import script from "./ArchiveStock.vue?vue&type=script&lang=js&"
export * from "./ArchiveStock.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveStock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchiveStock.vue"
export default component.exports